export const APP_VERSION = {
  version: "v3.3.0"
};
